<template>
	<div class="warp">
		<div class="form_grop">
			<van-cell-group>
			  <van-field
			    v-model="username"
			    required
			    clearable
			    label="姓名"
			    right-icon="question-a"
			    placeholder="请输入您的姓名"
			    size="large"
			  />
				
			<van-field
			    v-model="six"
			    required
			    clearable
			    label="性别"
			    right-icon="question-a"
			    placeholder="请选择您的性别"
			    size="large"
			    :readonly="true"
			    :is-link="true"
			    @click="showPickers=true"
			 />

			 <van-field
			    v-model="age"
			    required
			    clearable
			    label="年龄"
			    right-icon="question-a"
			    placeholder="请选择您的年龄"
			    size="large"
			    :readonly="true"
			    :is-link="true"
			     @click="showPick=true"
			 />

			 <van-field
			    v-model="iphone"
			    required
			    clearable
			    label="电话"
			    right-icon="question-a"
			    placeholder="请输入您的电话"
			    size="large"
			  />

			  <van-field
			    v-model="weixin"
			    required
			    clearable
			    label="微信"
			    right-icon="question-a"
			    placeholder="请输入您的微信号"
			    size="large"
			  />

			  <van-field
			    v-model="city"
			    required
			    clearable
			    label="所在城市"
			    right-icon="question-a"
			    placeholder="请选择您的所在城市"
			    size="large"
			    :readonly="true"
			    :is-link="true"
			    @click="showP=true"
			 />
			</van-cell-group>
			<van-button type="primary" size="large" @click="Submt">提交</van-button>
			<van-popup v-model="showPickers" position="bottom">
				<van-picker :columns="columns"  :show-toolbar="true" @cancel="Scancel" @change="onChange" @confirm="Sconfirm"/>
			</van-popup>
			<van-popup v-model="showPick" position="bottom">
				<van-picker :columns="ages" :show-toolbar="true"  @cancel="Acancel"  @change="onChan" @confirm="Aconfirm" />
			</van-popup>
			<van-popup v-model="showP" position="bottom">
				<van-picker :columns="colum" :show-toolbar="true" value-key="name" @change="onChangeM" @cancel="Dcancel" @confirm="Dconfirm" />
			</van-popup>
		</div>
	</div>
</template>
<script type="text/javascript">
	var citys = [
	    {id:111,'name':'杭州'},
	    {id:222,'name':'宁波'},
	    {id:333,'name':'温州'},
	    {id:444,'name':'嘉兴'},
	    {id:555,'name':'湖州'},
	];
	var country = {
	    '杭州':[
	        {id:111,'name':'国杭州'},
	        {id:222,'name':'国宁波'},
	        {id:333,'name':'国温州'},
	        {id:444,'name':'国嘉兴'},
	        {id:555,'name':'国湖州'},
	    ],
	    '宁波':[
	        {id:11,'name':'中'},
	        {id:222,'name':'中宁波'},
	        {id:333,'name':'中温州'},
	        {id:444,'name':'中嘉兴'},
	        {id:555,'name':'中湖州'},
	    ],
	    '温州':[
	        {id:112,'name':'中'},
	        {id:222,'name':'中波'},
	        {id:333,'name':'中温州'},
	        {id:444,'name':'中嘉兴'},
	        {id:555,'name':'中湖州'},
	    ],
	    '嘉兴':[
	        {id:113,'name':'中'},
	        {id:222,'name':'宁波'},
	        {id:333,'name':'中温州'},
	        {id:444,'name':'中嘉兴'},
	        {id:555,'name':'中湖州'},
	    ],
	    '湖州':[
	        {id:114,'name':'中'},
	        {id:222,'name':'中宁波'},
	        {id:333,'name':'中州'},
	        {id:444,'name':'中嘉兴'},
	        {id:555,'name':'中湖州'},
	    ]
	}
	export default {
		data(){
			return{
				username:'',
				age:'',
				showPickers:false,
				showPick:false,
				six:'',
				iphone:'',
				weixin:'',
				city:'',
				show:true,
				showP:false,
				action_id:'',
				columns: ['男', '女'],
				ages: ['20岁以下', '20-34岁','35-44岁','45-60岁','60岁以下'],
				datas:'',
				colum: [
				       {
				         values:citys,
				       },
				       {
				         values:country['杭州'],
				       }
				     ]
			}
		},
		mounted(){
			this.action_id=this.$route.query.action_id;
			/*console.log(this.action_id);
			this.getData();
			console.log(Vant,123)*/
		},
		methods:{
			onChange(picker, value, index) {
			    this.six=value;
			},
			onChan(picker, value, index) {
			    this.age=value;
			    //console.log(this.age,123456)
			},
			Scancel(){
				this.six='';
				this.showPickers=false;
			},
			Sconfirm(){
				this.showPickers=false;
			},
			Acancel(){
				this.age='';
				this.showPick=false;
			},
			Aconfirm(){
				this.showPick=false;
			},
			onChangeM(picker, values,index) {
			    picker.setColumnValues(1, country[values[0].name]);
			    this.city=values[0].name+'/'+values[1].name;
			    console.log(values,index)
			},
			Dcancel(){
				this.city='';
				this.showP=false;
			},
			Dconfirm(){
				this.showP=false;
			},
			//提交验证
			Submt(){
				if (this.username=='') {
					this.$toast('姓名不能为空')
				} else if(this.six==''){
					this.$toast('性别不能为空')
				} else if(this.age==''){
					this.$toast('年龄不能为空')
				} else if(this.six==''){
					this.$toast('性别不能为空')
				} else if(this.iphone==''){
					this.$toast('手机号不能为空')
				} else if(this.weixin==''){
					this.$toast('微信号不能为空')
				} else if(this.city==''){
					this.$toast('所在城市不能为空')
				}
			},
			getData(){
				var url="https://tulu-app.artron.net/wap/action/action_content?action_id="+this.action_id;
				this.$http.post(url,{			
				}).then((res)=>{
					this.data=res.data.data;
					console.log(res)
				}).catch((err)=>{
					console.log(err)
				})
			}
		}
	}
</script>
<style scoped>
	.van-cell--required::before {
	    content: '';
	    position: absolute;
	    left: 7px;
	    font-size: 14px;
	    color: #f44;
	}
	.van-button--large {
	    width: 90%;
	    height: 50px;
	    line-height: 48px;
	    bottom: 120px;
	    position: fixed;
	    left: 5%;
	}
</style>